// enum of all chegg-web cookie keys
export var CookieName = /*#__PURE__*/ function(CookieName) {
    // `access_token` is the Oauth access token for the user
    CookieName["ACCESS_TOKEN"] = "access_token";
    // `al_cell` is used for ads allocation
    CookieName["AL_CELL"] = "alCell";
    // chat paradigm experiment variant
    CookieName["CHAT_PARADIGM"] = "chat_paradigm";
    // Cloudfront country code header
    CookieName["CLOUDFRONT_COUNTRY_CODE"] = "country_code";
    // auto-apply coupon from query parameters
    CookieName["COUPON_CAMPAIGN"] = "coupon_campaign";
    // `applied_coupon_code` indicates a valid coupon code that has been applied
    CookieName["COUPON_CODE"] = "applied_coupon_code";
    // `CSessionID` is a Chegg Session ID used by NR logging (see chegg-web/chegg-web-app/libs/commerce/utils/logAuthNRFunnel.ts)
    CookieName["C_SESSION_ID"] = "CSessionID";
    // `CSID` is the Chegg Session ID
    CookieName["CSID"] = "CSID";
    // `CVID` is the Chegg Visitor ID
    CookieName["CVID"] = "CVID";
    // 'DFID' is the Chegg Device ID
    CookieName["DFID"] = "DFID";
    // `ec_upload_pending` indicates a paper has been submitted for Expert Check (writing center) but ticket may not be available for retrieval
    CookieName["EC_UPLOAD_PENDING"] = "ec_upload_pending";
    // To enable sandbox mode for copyleaks on writing tools
    CookieName["ENABLE_CL_SANDBOX"] = "enable-cl-sandbox";
    // 'Automated Engine' is enabled for test environment persistence of aa experiment
    CookieName["EXP_AA"] = "chegg_web_cbr_aa_experiment";
    // AI Toggle experience is enabled.
    CookieName["EXP_AI_TOGGLE"] = "ai_toggle_exp";
    // `chegg_web_cbr_exp_mtc` is enabled for test environment persistence of MTC experiment
    CookieName["EXP_MTC"] = "chegg_web_cbr_exp_mtc";
    // `chegg_web_cbr_exp_mtc` is enabled for test environment persistence of MTC dev tool
    CookieName["EXP_MTC_DEBUG_TOOL"] = "chegg_web_mtc_debug_tool";
    // `chegg_web_mtc_skip_search` is enabled for test environment persistence of MTC skip search tool
    CookieName["EXP_MTC_SKIP_SEARCH"] = "chegg_web_mtc_skip_search";
    // `chegg_web_cbr_exp_opt_in` used for opting into experimentation bucketing in test env
    CookieName["EXP_OPT_IN"] = "chegg_web_cbr_exp_opt_in";
    // `chegg_web_cbr_exp_rag_solution` is enabled for RAG solution test
    CookieName["EXP_RAG_SOLUTION"] = "chegg_web_cbr_exp_rag_solution";
    // `chegg_web_cbr_exp_uae` is enabled for test environment persistence of UAE experiment
    CookieName["EXP_UAE"] = "chegg_web_cbr_exp_uae";
    // 'exp' is a cookie used when capturing errors in NewRelic (see chegg-web/packages/CommerceUtils/src/utils/NewRelicUtils/index.ts)
    CookieName["EXPERIMENT"] = "exp";
    // `V` is a cookie containing the unique id used to bucket users into optimizely experiments
    CookieName["EXPERIMENT_IDENTIFIER"] = "V";
    // `expert_questions_on_content_exp` is used to enable expert solutions on content page feature.
    CookieName["EXPERT_SOLUTIONS_ON_CONTENT_EXP"] = "expert-solutions-on-content-exp";
    // 'forterToken'
    CookieName["FORTER_TOKEN"] = "forterToken";
    // user geo location
    CookieName["GEOLOCATION"] = "user_geo_location";
    // to hide the desktop to app uic modal if its shown once in a day
    CookieName["HIDE_DESKTOP_TO_APP_UIC_MODAL"] = "hide_desktop_to_app_uic_modal";
    // to hide the get chegg app CTA if its shown once in a day
    CookieName["HIDE_GET_APP_CTA"] = "hide_get_app_cta";
    // to hide the mweb to app signin modal if its shown once in a day
    CookieName["HIDE_MWEB_TO_APP_SIGNIN_MODAL"] = "hide_mweb_to_app_signin_modal";
    // to hide rating promotion tooltip, if its shown once in a day
    CookieName["HIDE_RATING_PROMOTION_TOOLTIP"] = "hide_rating_promotion_tooltip";
    // Determine whether user has accepted honor code to view answer in past 24 hours
    CookieName["HONOR_CODE_OPT_IN"] = "honor_code_opt_in";
    // 'hwh_id' may be obsolete
    CookieName["HWH_ID"] = "hwh_id";
    // 'hwh_key' may be obsolete
    CookieName["HWH_KEY"] = "hwh_key";
    // `id_token` is the Chegg JWT for the user
    CookieName["ID_TOKEN"] = "id_token";
    // `is_new_login_mweb_to_app_expansion_modal` is set to true when a user signs in on any page
    CookieName["IS_NEW_lOGIN_MWEB_TO_APP_EXPANSION_MODAL"] = "is_new_login_mweb_to_app_expansion_modal";
    // identifier for legacy chegg.com session (sessionData.user.uuid)
    CookieName["JERICHO_SESSION"] = "PHPSESSID";
    // `lang_preference` is the language preference cookie
    CookieName["LANG_PREFERENCE"] = "langPreference";
    // fetch last accessed subject for mathway user
    CookieName["LAST_ACCESSED_SUBJECT"] = "last_accessed_subject";
    // better math formatting tooltip
    CookieName["MATH_MODE_TOOLTIP"] = "math_mode_tooltip";
    // enable mathmode tooltip
    CookieName["MATH_PROBLEM_TOOLTIP"] = "math_problem_tooltip";
    // multiple image support for mtc-send-to-expert
    CookieName["MULTIPLE_IMAGE_TOOLTIP"] = "multiple_image_tooltip";
    // OFS user profile cookie
    CookieName["OPT_USER_PROFILE"] = "opt-user-profile";
    // `order_redirect` is the redirect url after completing an order
    CookieName["ORDER_REDIRECT"] = "hwh_order_ref";
    // `sbm_previous_truex_gcs` is set to 'true' by sbm-unlock after the user has viewed unlock, with a custom expiration set by SBM team
    CookieName["PREVIOUS_TRUEX"] = "sbm_previous_truex_gcs";
    // `qa_audience` is manual set cookie for testing optimizely features on production
    CookieName["QA_AUDIENCE"] = "qa_audience";
    // `reworked_search_exp` is used for forcing into the new search experience.
    CookieName["REWORKED_SEARCH_EXP"] = "reworked-search-exp";
    // 'U' is a cookie used when capturing errors in NewRelic (see chegg-web/packages/CommerceUtils/src/utils/NewRelicUtils/index.ts)
    CookieName["U"] = "U";
    // 'USER_STATE' is a cookie used to propagate the user state of signed-out, sub, non-sub
    CookieName["USER_STATE"] = "user_state";
    // 'RECOMMENDATION_VISITED' is a cookie used to track if the user has visited the recommendation
    CookieName["RECOMMENDATION_VISITED"] = "recommendation_visited";
    // 'SHOULD_REFRESH_TOKEN' is a cookie used to track if the user should refresh their token
    CookieName["SHOULD_REFRESH_TOKEN"] = "should-refresh-token";
    return CookieName;
}({});
// Enum for cookie values of user-state
export var UserStateCookieValues = /*#__PURE__*/ function(UserStateCookieValues) {
    UserStateCookieValues["SIGNED_OUT"] = "signed-out";
    UserStateCookieValues["NON_SUB"] = "non-sub";
    UserStateCookieValues["SUB"] = "sub";
    return UserStateCookieValues;
}({});
